import {classes, IntrinsicElementProps} from "@/utils";
import {TwoToneText} from "./TwoToneText";
import React, {ReactNode} from "react";
import styled from "styled-components";
import {Media} from "@/constants";
import classnames from "classnames";

export function PageTitle({w1, w2, reverse, className, ...props}: { w1: ReactNode, w2?: ReactNode, reverse?: boolean } & IntrinsicElementProps) {
    return <Container {...props} className={classnames(`getApp ${classes.text_3_6} pt-16 pb-8`, className)}><TwoToneText w1={w1} w2={w2} reverse={reverse}/></Container>
}

const Container = styled.div`
    text-align: center;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);
    //font-style: normal;
    //font-weight: 500;
    letter-spacing: 0.64px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    //font-size: 2rem;

    @media screen and (${Media.md}) {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        //font-size: 2.5rem;
        //line-height: 3rem;
    }
    @media screen and (${Media.lg}) {
        //font-size: 3rem;
        //line-height: 3.5rem
    }
    @media screen and (${Media.xl}) {
        //font-size: 4rem;
        //line-height: 4.5rem;
    }

    .two-tone-text {
        text-align: center;
    }
`;
